import { CreatorProductModule } from './CreatorProductModuleApi';
import { Attachment, ObjectAvailability, Store, UUID } from '@/types/types';
import { ProductModuleCollection } from './ProductModuleCollectionApi';
import { QueryKey } from '@/configs/queryKeys';
import { SerializedRenderer } from '@/renderer/types';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';
import axios from 'axios';
import ProductModuleApi from './ProductModuleApi';

export enum PresetStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export interface PresetStoreConfiguration {
	store: Store;
	listOrder: number;
	status: ObjectAvailability;
}

export interface Preset extends BaseEntity {
	name: string;
	image?: Attachment;
	creatorProductModules: CreatorProductModule[];
	productModuleCollection?: ProductModuleCollection;
	listOrder: number;
	price: number;
	status: PresetStatus;
	options: {
		renderer?: SerializedRenderer;
	};
	storeConfigurations: PresetStoreConfiguration[];
}

class PresetApi extends EntityApi<Preset> {
	constructor() {
		super(QueryKey.presets);
		this.clear = this.clear.bind(this);
		this.getWithoutStore = this.getWithoutStore.bind(this);
	}

	async getWithoutStore({
		presetId,
		storeId,
	}: {
		presetId: UUID;
		storeId: UUID;
	}): Promise<Preset> {
		const response = await axios.get<Preset>(
			`${import.meta.env.VITE_API_URL}${this.queryKey}/${presetId}`,
			{
				headers: {
					'x-store-id': '',
				},
			}
		);

		const creatorProductModules = response.data.creatorProductModules;

		for (const creatorProductModule of creatorProductModules) {
			const productModule = await ProductModuleApi.mutationGetOne(
				creatorProductModule.productModuleId
			);
			creatorProductModule.productModule = productModule;

			const productModuleStoreConfiguration =
				productModule.storeConfigurations.find(
					(storeConfiguration) => storeConfiguration.store.id === storeId
				);

			if (!productModuleStoreConfiguration)
				throw new Error('Product module store configuration not found');

			creatorProductModule.productModule!.storeConfiguration =
				productModuleStoreConfiguration;
		}

		return response.data;
	}

	async clear(id: UUID) {
		const response = await httpClient.patch<Preset>(
			`${this.queryKey}/${id}/clear`
		);
		return response.data;
	}
}

export default new PresetApi();
